import React, { useState } from "react";
import styles from "./OrderForm.module.css";
import { Field, Formik, Form } from "formik";
import {
  Button,
  InputGroup,
  Form as BootstrapForm,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import * as Yup from "yup";
import { setForm } from "../../actions/Form.action";
import dropdownServices from "../../constant/dropdownOptionsService";
import { useNavigate, useSearchParams } from "react-router-dom";
import { connect } from "react-redux";

const OrderForm = ({ setForm }) => {
  const [submitting, setSubmitting] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const onSubmitHandeler = async (values) => {
    setForm(values);
    navigate(`/order/${values.serviceNeeded}`);
  };
  let initVals = {
    name: "",
    email: "",
    company: "",
    project: "",
    contactNumber: "",
    deliveryAddress: "",
    deliveryDate: "",
    serviceNeeded:
      searchParams.get("type") && searchParams.get("type") !== "3D-Printing"
        ? searchParams.get("type")
        : "3D-Printing-fdm",
  };

  const OrderSchema = Yup.object().shape({
    name: Yup.string().required("Name is required!"),
    email: Yup.string()
      .email("Enter valid email address!")
      .required("Email is required!"),
    company: Yup.string().required("Company is required!"),
    project: Yup.string().required("Project is required!"),
    contactNumber: Yup.string().required("Contact Number is required!"),
    deliveryAddress: Yup.string().required("Delivery Address is required!"),
    deliveryDate: Yup.string().required("Delivery Date is required!"),
    serviceNeeded: Yup.string().required("Select a service!"),
  });

  return (
    <div className={styles.wrapper}>
      <Formik
        initialValues={initVals}
        validationSchema={OrderSchema}
        onSubmit={(values) => onSubmitHandeler(values)}
      >
        {({ errors, touched, setFieldValue }) => (
          <Form>
            <Container className="p-md-5 p-3">
              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="name" className="d-block">
                        Your name
                      </label>
                      {errors.name && touched.name ? (
                        <small className="text-danger">{errors.name}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your name..."
                      name="name"
                      isValid={!errors.name && touched.name}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.name && touched.name}
                    />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="email" className="d-block">
                        Contact Email
                      </label>
                      {errors.email && touched.email ? (
                        <small className="text-danger">{errors.email}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your email address..."
                      name="email"
                      isValid={!errors.email && touched.email}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.email && touched.email}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="company" className="d-block">
                        Company name
                      </label>
                      {errors.company && touched.company ? (
                        <small className="text-danger">{errors.company}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your company name..."
                      name="company"
                      isValid={!errors.company && touched.company}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.company && touched.company}
                    />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="project" className="d-block">
                        Project name
                      </label>
                      {errors.project && touched.project ? (
                        <small className="text-danger">{errors.project}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your project name..."
                      name="project"
                      isValid={!errors.project && touched.project}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.project && touched.project}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="contactNumber" className="d-block">
                        Contact Number
                      </label>
                      {errors.contactNumber && touched.contactNumber ? (
                        <small className="text-danger">
                          {errors.contactNumber}
                        </small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your contact number..."
                      name="contactNumber"
                      isValid={!errors.contactNumber && touched.contactNumber}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.contactNumber && touched.contactNumber}
                    />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="deliveryAddress" className="d-block">
                        Delivery Address
                      </label>
                      {errors.deliveryAddress && touched.deliveryAddress ? (
                        <small className="text-danger">
                          {errors.deliveryAddress}
                        </small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your desired delivery address..."
                      name="deliveryAddress"
                      isValid={
                        !errors.deliveryAddress && touched.deliveryAddress
                      }
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={
                        errors.deliveryAddress && touched.deliveryAddress
                      }
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="deliveryDate" className="d-block">
                        Delivery Date
                      </label>
                      {errors.deliveryDate && touched.deliveryDate ? (
                        <small className="text-danger">
                          {errors.deliveryDate}
                        </small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your desired delivery date..."
                      name="deliveryDate"
                      isValid={!errors.deliveryDate && touched.deliveryDate}
                      type="date"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.deliveryDate && touched.deliveryDate}
                    />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="serviceNeeded" className="d-block">
                        Service Needed
                      </label>
                      {errors.serviceNeeded && touched.serviceNeeded ? (
                        <small className="text-danger">
                          {errors.serviceNeeded}
                        </small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Select}
                      placeholder="Type your country address..."
                      name="serviceNeeded"
                      isValid={!errors.serviceNeeded && touched.serviceNeeded}
                      className={`${styles.input} w-100`}
                      isInvalid={errors.serviceNeeded && touched.serviceNeeded}
                    >
                      {dropdownServices
                        .filter((ds, i) => i !== 5)
                        .map((item, i) => (
                          <option key={i} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                    </Field>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="pt-3 d-flex justify-content-center align-items-center">
                  <Button
                    type="submit"
                    className={`.btn_primary ${styles.btn}`}
                    disabled={submitting}
                  >
                    {submitting ? "Submitting..." : "Next"}
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        )}
      </Formik>
    </div>
  );
};
export default connect(null, { setForm })(OrderForm);
